import { writeStorage } from "@rehooks/local-storage";
import { useEffect, useState } from "react";

import useDarkMode from "../../hooks/useDarkMode.hook";
import NightIcon from "../../icons/night.icon";
import SunIcon from "../../icons/sun.icon";

export default function ApperanceToggleComp() {
  const [ready, setReady] = useState(false);
  const isDark = useDarkMode();

  // avoid the hydration mismatched
  useEffect(() => {
    setInterval(() => {
      setReady(true);
    }, 10);
  }, []);

  if (!ready) return <LightToggle />;
  return isDark ? <DarkToggle /> : <LightToggle />;
}

function DarkToggle() {
  return (
    <button
      onClick={() => {
        writeStorage("theme", "light");
      }}
    >
      <SunIcon className="w-6 h-6 text-her-dodgerblue" />
    </button>
  );
}

function LightToggle() {
  return (
    <button
      onClick={() => {
        writeStorage("theme", "dark");
      }}
    >
      <NightIcon className="w-6 h-6 text-her-dodgerblue" />
    </button>
  );
}
